import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { LayoutContainer, MainContent } from './styled';
import {
  selectAdriverSelectedCity,
  selectSearchFormCurrentState
} from '../../store/selectors';
import { BUILDING_TYPE_ID } from '../../utils/helpers/constants';
import { useAdriverTargeting } from '../../hooks/useTargetedBanner/useAdriverTargeting';

export const HomeLayoutWithBanner = ({
  shouldLoadBanner = true,
  children
}: {
  shouldLoadBanner?: boolean;
  children: ReactNode;
}) => {
  const storedFormState = useSelector(selectSearchFormCurrentState);
  const cityName: string = useSelector(selectAdriverSelectedCity);
  const categoryId = storedFormState?.category_id || BUILDING_TYPE_ID.FLAT_ALL;

  useAdriverTargeting({
    leased: storedFormState?.leased,
    rooms:
      storedFormState?.room_ids?.length &&
      parseInt(storedFormState.room_ids[0], 10),
    categoryId,
    hasRepair: storedFormState?.has_repair,
    cityName,
    price: storedFormState?.price_from || storedFormState?.price_to,
    hasBillOfSale: storedFormState?.has_bill_of_sale,
    hasMortgage: storedFormState?.has_mortgage,
    shouldLoad: shouldLoadBanner
  });

  return (
    <LayoutContainer>
      <MainContent>{children}</MainContent>
    </LayoutContainer>
  );
};
